// @mui material components
import BarChartIcon from "@mui/icons-material/BarChart";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import PsychologyIcon from "@mui/icons-material/Psychology";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import bgImageProfessionals from "assets/images/bg_professionals.webp";
import bgImage from "assets/images/braingage-bg.webp";
import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";
import DefaultFooter from "examples/Footers/DefaultFooter";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import footerRoutes from "footer.routes";
import routes from "webRoutes";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function BrainGage() {
  return (
    <>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "internal",
          route: "/pages/landing-pages/contact-us",
          label: "Contact Us",
          color: "info",
        }}
        sticky
      />
      <MKBox
        minHeight="75vh"
        width="100%"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "top",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
            <MKTypography
              variant="h1"
              color="white"
              mt={-6}
              mb={1}
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
              style={textStyles}
            >
              Welcome to BrainGage{" "}
            </MKTypography>
            <MKTypography
              variant="body1"
              color="white"
              style={textStyles}
              textAlign="center"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
              Unlock the Power of Neuroscience in Understanding Human Potential
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <MKBox component="section" py={{ xs: 3, md: 12 }}>
          <Container>
            <Grid container spacing={3} sx={{ mb: 10 }}>
              <Grid item xs={12} lg={5}>
                <MKBox position="sticky" top="100px" pb={{ xs: 2, lg: 6 }}>
                  <MKTypography variant="h3" my={1}>
                    Why BrainGage?
                  </MKTypography>
                  <MKTypography variant="body2" color="text" mb={2}>
                    At BrainGage, we&apos;re at the forefront of leveraging cutting-edge
                    neuroscience to decode the complexities of human cognition, behavior, and
                    personality. Our innovative SaaS platform offers a suite of cognitive and
                    behavioral games designed to provide deep insights into individuals capabilities
                    and predict their efficiency for specific roles with unprecedented accuracy.
                  </MKTypography>
                </MKBox>
                {/* <MKTypography
                  component="a"
                  href="#"
                  variant="body2"
                  color="info"
                  fontWeight="regular"
                  sx={{
                    width: "max-content",
                    display: "flex",
                    alignItems: "center",

                    "& .material-icons-round": {
                      fontSize: "1.125rem",
                      transform: "translateX(3px)",
                      transition: "transform 0.2s cubic-bezier(0.34, 1.61, 0.7, 1.3)",
                    },

                    "&:hover .material-icons-round, &:focus .material-icons-round": {
                      transform: "translateX(6px)",
                    },
                  }}
                >
                  More about us
                  <Icon sx={{ fontWeight: "bold" }}>arrow_forward</Icon>
                </MKTypography> */}
              </Grid>
              <Grid item xs={12} lg={6} sx={{ ml: { xs: -2, lg: "auto" }, mt: { xs: 6, lg: 0 } }}>
                <Stack>
                  <MKBox display="flex" alignItems="center" p={2}>
                    <MKBox
                      width="3rem"
                      height="3rem"
                      variant="gradient"
                      bgColor="info"
                      color="white"
                      coloredShadow="info"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      borderRadius="xl"
                    >
                      {/* <Icon fontSize="small">mediation</Icon> */}
                      <PsychologyIcon />
                    </MKBox>
                    <MKTypography variant="body2" color="text" pl={2}>
                      <MKTypography variant="h6">Neuroscience-driven Insights:</MKTypography>
                      Our platform goes beyond traditional assessments by harnessing the power of
                      neuroscience. Understand your team or candidates on a whole new level with
                      insights grounded in scientific research.
                    </MKTypography>
                  </MKBox>
                  <MKBox display="flex" alignItems="center" p={2}>
                    <MKBox
                      width="3rem"
                      height="3rem"
                      variant="gradient"
                      bgColor="info"
                      color="white"
                      coloredShadow="info"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      borderRadius="xl"
                    >
                      <BarChartIcon />
                    </MKBox>
                    <MKTypography variant="body2" color="text" pl={2}>
                      <MKTypography variant="h6">Predictive Analytics:</MKTypography>
                      Say goodbye to guesswork. BrainGage&apos;s advanced algorithms analyze
                      cognitive, behavioral, and personality patterns to predict individuals
                      suitability and performance in specific roles with precision.
                    </MKTypography>
                  </MKBox>
                  <MKBox display="flex" alignItems="center" p={2}>
                    <MKBox
                      width="3rem"
                      height="3rem"
                      variant="gradient"
                      bgColor="info"
                      color="white"
                      coloredShadow="info"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      borderRadius="xl"
                    >
                      <FactCheckIcon />
                    </MKBox>
                    <MKTypography variant="body2" color="text" pl={2}>
                      <MKTypography variant="h6">Personalized Assessments:</MKTypography>
                      Tailor assessments to your organization&apos;s needs with a wide range of
                      cognitive and behavioral games. Whether you&apos;re hiring, training, or
                      building high-performing teams, BrainGage offers customizable solutions for
                      every scenario.
                    </MKTypography>
                  </MKBox>
                  <MKBox display="flex" alignItems="center" p={2}>
                    <MKBox
                      width="3rem"
                      height="3rem"
                      variant="gradient"
                      bgColor="info"
                      color="white"
                      coloredShadow="info"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      borderRadius="xl"
                    >
                      <LightbulbIcon />
                    </MKBox>
                    <MKTypography variant="body2" color="text" pl={2}>
                      <MKTypography variant="h6">Continuous Improvement:</MKTypography>
                      Drive ongoing growth and development with actionable insights from BrainGage.
                      Empower individuals to understand their strengths, areas for improvement, and
                      unlock their full potential.
                    </MKTypography>
                  </MKBox>
                </Stack>
              </Grid>
            </Grid>
            <Grid item>
              <MKBox display="flex" alignItems="center" justifyContent="center" p={2}>
                <MKTypography variant="h3">Features</MKTypography>
              </MKBox>
            </Grid>
            <Grid item xs={12} lg={7} sx={{ ml: "auto" }}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <FilledInfoCard
                    icon="sports_esports"
                    title="Cognitive Games"
                    description="Engage users with a variety of brain-training exercises designed to enhance cognitive skills such as memory, attention, problem-solving, and more."
                    // action={{
                    //   type: "internal",
                    //   route: "/pages/landing-pages/eval-ai",
                    //   label: "Read more",
                    // }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <FilledInfoCard
                    icon="assessment"
                    title="Behavioral Assessments"
                    description="Dive deep into individuals' behavioral patterns with scientifically validated assessments that uncover traits like resilience, adaptability, communication style, and emotional intelligence."
                    // action={{
                    //   type: "internal",
                    //   route: "/test",
                    //   label: "Read more",
                    // }}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3} sx={{ mt: { xs: 0, md: 6 } }}>
                <Grid item xs={12} md={6}>
                  <FilledInfoCard
                    icon="face"
                    title="Personality Profiling"
                    description="Gain a nuanced understanding of individuals' personality traits and preferences to ensure cultural fit and team cohesion."
                    // action={{
                    //   type: "internal",
                    //   route: "/test",
                    //   label: "Read more",
                    // }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <FilledInfoCard
                    icon="online_prediction"
                    title="Role-specific Predictions"
                    description="Receive personalized recommendations and predictions for each individual's suitability for specific roles within your organization based on their cognitive, behavioral, and personality profiles."
                    // action={{
                    //   type: "internal",
                    //   route: "/test",
                    //   label: "Read more",
                    // }}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <MKBox display="flex" alignItems="center" justifyContent="center" p={2}>
                <MKTypography variant="h3">Unlock Human Potential with BrainGage</MKTypography>
              </MKBox>
              <MKBox display="flex" alignItems="center" justifyContent="center" pb={2}>
                <MKTypography variant="body1">
                  Ready to harness the power of neuroscience to build stronger, more effective
                  teams? Sign up for BrainGage today and revolutionize the way you understand and
                  optimize human potential.
                </MKTypography>
              </MKBox>
            </Grid>
            <Grid item xs={12} lg={7} sx={{ ml: "auto" }}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <MKBox
                    display="flex"
                    alignItems="center"
                    borderRadius="xl"
                    my={2}
                    py={6}
                    sx={{
                      backgroundImage: ({
                        functions: { linearGradient, rgba },
                        palette: { gradients },
                      }) =>
                        `${linearGradient(
                          rgba(gradients.dark.main, 0.8),
                          rgba(gradients.dark.state, 0.8)
                        )}, url(${bgImageProfessionals})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  >
                    <Container>
                      <Grid container item xs={12} lg={10} sx={{ ml: { xs: 0, lg: 6 } }}>
                        <MKTypography variant="h4" color="white" fontWeight="bold">
                          For Organizations
                        </MKTypography>
                        <MKTypography variant="body1" color="white" opacity={0.8} mb={2}>
                          Drive organizational success by making data-driven decisions in hiring,
                          training, and talent development with BrainGage.
                        </MKTypography>
                      </Grid>
                    </Container>
                  </MKBox>
                </Grid>
                {/* <Grid item xs={12} md={6}>
                  <MKBox
                    display="flex"
                    alignItems="center"
                    borderRadius="xl"
                    my={2}
                    py={6}
                    sx={{
                      backgroundImage: ({
                        functions: { linearGradient, rgba },
                        palette: { gradients },
                      }) =>
                        `${linearGradient(
                          rgba(gradients.dark.main, 0.8),
                          rgba(gradients.dark.state, 0.8)
                        )}, url(${bgImageStudents})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  >
                    <Container>
                      <Grid container item xs={12} lg={10} sx={{ ml: { xs: 0, lg: 6 } }}>
                        <MKTypography variant="h4" color="white" fontWeight="bold">
                          For Students
                        </MKTypography>
                        <MKTypography variant="body1" color="white" opacity={0.8} mb={2}>
                          Showcase your skills and expertise in a fair and unbiased environment.
                          Take your career to new heights with EvalAI.
                        </MKTypography>
                      </Grid>
                    </Container>
                  </MKBox>
                </Grid> */}
              </Grid>
            </Grid>
          </Container>
        </MKBox>
      </Card>
      <MKBox pt={4} px={1} mt={4}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

const textStyles = { textShadow: "2px 2px 4px #000000", color: "##C0C0C0" };

export default BrainGage;
